import { Component, OnInit, signal } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

type NavItem = {
  path: string;
  label: string;
  description: string;
};

@Component({
  selector: 'app-shell',
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './app-shell.component.html',
  styleUrl: './app-shell.component.scss',
})
export class AppShellComponent implements OnInit {
  protected readonly dark = signal(
    typeof window !== 'undefined' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches,
  );

  ngOnInit(): void {
    document.documentElement.dataset['theme'] = this.dark() ? 'dark' : 'light';
  }

  protected readonly nav: NavItem[] = [
    { path: '/', label: 'Home', description: 'Overview' },
    { path: '/validate', label: 'Validate filing', description: 'EBA validation' },
    { path: '/reports', label: 'Report viewer', description: 'Report package data' },
    { path: '/compare', label: 'Compare filings', description: 'Diff two filings' },
    { path: '/trend', label: 'Period comparison', description: 'Trend across periods' },
    { path: '/build', label: 'Build report package', description: 'Excel to xBRL-CSV (.zip)' },
    { path: '/dev', label: 'Developer', description: 'Spike lab' },
  ];

  protected toggleTheme(): void {
    this.dark.update((v) => !v);
    document.documentElement.dataset['theme'] = this.dark() ? 'dark' : 'light';
  }
}
